import Axios from 'axios'
import store from '../store'

const roomBooking = {
  getFreeroomUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_FREEROOM
  },
  getClientIdFreeroom () {
    return store.getters['Client/clientIdFreeroom']
  },
  deleteBookingOfAnUser (userEmail, eventId) {
    return Axios.delete(`${this.getFreeroomUrl()}/api/public/clients/${this.getClientIdFreeroom()}/users/${userEmail}/events/${eventId}`)
  }
}

export default roomBooking
